import { useMemo } from 'react';
import { detectPlatform, type DevicePlatform } from '../utils/deviceDetection';

/** Returns the detected device platform (ios / android / desktop). */
export function useDevicePlatform(): DevicePlatform {
  return useMemo(() => detectPlatform(), []);
}
